import template from './vaccine-detail.html';
import controller from './vaccine-detail.controller';

let vaccineDetailComponent = {
  bindings: {},
  template,
  controller
};

export default vaccineDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine-detail.component.js